import { defineStore } from 'pinia';
import { StatesService } from '@/services';
import { StateInterface } from '@/types';

export default defineStore('StatesStore', {
  state: () => {
    return {
      loading: false,
      states: [] as StateInterface[],
    };
  },

  actions: {
    async getStates(usStates = false) {
      this.loading = true;
      const response = await StatesService.getStates();
      if (usStates) {
        this.states = response.data.data.filter((state: StateInterface) => state.country_code === 'US');
      } else {
        this.states = response.data.data;
      }
      this.loading = false;
    },
  },
});
